import { fromJS, Record } from 'immutable';

export const skusRecord = new Record({
  byId: fromJS({}),
  allIds: fromJS([]),
  byProjectId: fromJS({})
});

export default skusRecord();
